@let fundOnHold = fundOnHold$ | async;
@let financialAccount = financialAccount$ | async;
@let createdBy = fundOnHold?.createdBy?.id | teamMemberName | async;
@let updatedBy = fundOnHold?.updatedBy?.id | teamMemberName | async;

@if (!fundOnHold) {
  <app-details-page-header-placeholder [pageReturnURL]="pageReturnURL" [withStatus]="false"></app-details-page-header-placeholder>
  <app-details-page-content-placeholder [singleColumn]="true" />
} @else {
  <app-details-page-header [pageReturnURL]="pageReturnURL" [title]="'Funds on Hold Details'" [breadcrumbs]="breadcrumbList">
    <div class="flex items-center">
      <button
        appRemoveFocus
        class="p-2 text-2xl text-secondary rounded-full transition-colors hover:bg-white"
        (click)="onEditBtnClick()"
        title="Edit Fund On Hold"
        [disabled]="fundOnHold.status !== 'ACTIVE'"
      >
        <rkt-icon name="edit"></rkt-icon>
      </button>
    </div>
  </app-details-page-header>

  <div class="flex gap-5">
    <div class="bg-white rounded-lg px-6 py-5 mt-5 flex-1">
      <div class="grid gap-x-16 gap-y-5 w-full xl:w-3/3 lg:grid-cols-3">
        <app-details-item-id label="Hold ID" [id]="fundOnHold.id" />

        <app-details-item-id label="Financial Account ID" [link]="[financialAccountUrl]" [id]="fundOnHold.financialAccountId" />

        <app-details-item label="Expiry Date" [value]="fundOnHold.expiry | dateFormat" />

        <app-details-item label="Total Amount" [value]="fundOnHold.amount | amount: financialAccount?.currency" />

        <app-details-item label="Status" [value]="fundOnHold.status">
          <span class="status-tag" [ngClass]="'status-tag-' + fundOnHold.status.toLowerCase()">
            {{ fundOnHold.status | titlecase }}
          </span>
        </app-details-item>

        <app-details-item label="Memo" [value]="fundOnHold.memo" />

        <app-details-item label="External Ref ID" [value]="fundOnHold.externalReferenceId" />

        @if (fundOnHold.releasedTransactionId) {
          <app-details-item-id label="Released Transaction ID" [link]="[releasedTransactionUrl]" [id]="fundOnHold.releasedTransactionId" />
        } @else {
          <app-details-item label="Released Transaction ID" />
        }
      </div>

      <div class="separator"></div>

      <div class="grid gap-x-16 gap-y-5 w-full xl:w-2/3 lg:grid-cols-2">
        <app-details-item label="Created By" [value]="createdBy" />
        <app-details-item label="Created At" [value]="fundOnHold.createdAt | dateFormat" />
        <app-details-item label="Updated By" [value]="updatedBy" />
        <app-details-item label="Updated At" [value]="fundOnHold.updatedAt | dateFormat" />
      </div>
    </div>
  </div>
}
